module.exports = __webpack_public_path__ + "img/agenda.5e93796b.svg";